module.exports = require('./lib/gridduck.js');
